<h2 mat-dialog-title>Invite to {{ data.entityName }}</h2>

<mat-dialog-content>
  <p class="invite-dialog__lead">
    Send an email invitation. They'll set up their own account and join this business.
  </p>

  @if (serverError()) {
    <div class="invite-dialog__error" role="alert" aria-live="assertive">
      {{ serverError() }}
    </div>
  }

  <form class="invite-dialog__form" [formGroup]="form" novalidate (ngSubmit)="submit()">
    <div class="field-group">
      <label class="field-label" for="inviteEmail">
        Their email <span class="required-mark" aria-hidden="true">*</span>
      </label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          id="inviteEmail"
          type="email"
          formControlName="email"
          placeholder="owner@business.co.za"
          autocomplete="off"
        />
        <mat-error>
          @if (form.controls.email.hasError('required')) {
            Email is required
          } @else if (form.controls.email.hasError('email')) {
            Enter a valid email address
          } @else if (form.controls.email.hasError('serverError')) {
            {{ form.controls.email.getError('serverError') }}
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="field-group">
      <label class="field-label" for="inviteRole" id="inviteRoleLabel">
        Role <span class="required-mark" aria-hidden="true">*</span>
      </label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select id="inviteRole" formControlName="role" aria-labelledby="inviteRoleLabel">
          @for (r of ROLES; track r.value) {
            <mat-option [value]="r.value">{{ r.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <p class="invite-dialog__hint">{{ roleHint }}</p>
    </div>

    <div class="field-group">
      <label class="field-label" for="inviteMessage">Personal note (optional)</label>
      <mat-form-field appearance="outline" class="full-width">
        <textarea
          matInput
          id="inviteMessage"
          formControlName="message"
          rows="2"
          placeholder="Add a short note to the invitation email"
        ></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()" [disabled]="isSaving()">
    Cancel
  </button>
  <button
    mat-flat-button
    type="button"
    (click)="submit()"
    [disabled]="isSaving()"
    [attr.aria-busy]="isSaving() || null"
    data-testid="invite-send-btn"
  >
    @if (isSaving()) {
      <mat-spinner diameter="18" aria-hidden="true" />
      <span>Sending…</span>
    } @else {
      Send invitation
    }
  </button>
</mat-dialog-actions>
